"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IndexHit = function (_a) {
    var hit = _a.hit, _b = _a.showCity, showCity = _b === void 0 ? true : _b;
    return (react_1.default.createElement(react_1.default.Fragment, { key: hit.objectID },
        showCity && (react_1.default.createElement("h4", { className: "py-4 font-semibold uppercase text-sm" }, hit.city || hit.address_city)),
        react_1.default.createElement("div", { className: (showCity ? 'col-start-2' : '') + " py-4 grid md:grid-cols-2 lg:grid-cols-3 border-b border-gray-300" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("a", { className: "text-teal-500 underline font-medium", href: hit.url }, hit.title),
                hit.availability !== '' && (react_1.default.createElement("div", { className: "absolute flex items-center justify-center top-0 left-0 bg-gray-300 text-gray-500 rounded-full w-6 h-6 -ml-10" },
                    react_1.default.createElement("i", { className: "far fa-crown text-xs" })))),
            react_1.default.createElement("div", { className: "hidden lg:block" }, hit.residence_categories.map(function (category) { return window.__(category); }).join(', ')),
            react_1.default.createElement("div", { className: "md:text-right" },
                react_1.default.createElement("a", { href: "tel:" + hit.phone }, hit.phone),
                react_1.default.createElement("br", null),
                react_1.default.createElement("a", { className: "text-teal-500 underline", href: "mailto:" + hit.email }, hit.email)))));
};
exports.default = IndexHit;
